


export const counterData = {
   Projects: 10,
   Experience:1,
   Blogs:3
    
}

